import React from 'react';
import {getBrand} from '../../assets/getBrand';
import {IconBadge, SVGIcon} from '@resurs-internal/mui';
import {SVGIconProps} from '@resurs-internal/mui/components/SVGIcon/SVGIcon';

export const BrandIcon: React.FC<{
  chainId: string | number | undefined;
  size?: SVGIconProps['size'];
}> = ({chainId, size}) => {
  const brand = getBrand(chainId);
  if (!brand) {
    return <IconBadge type={'font'} icon={'credit-card'} size={size} />;
  }
  return <SVGIcon name={brand.url} size={size} alt={brand.name} />;
};
